import React from 'react';
import CustomTextField, { CustomTextFieldProps } from './customTextField';
import IconEdit from 'shared/icons/iconEdit';

export default function EditTextField({ ...props }: CustomTextFieldProps) {
  return (
    <CustomTextField
      InputProps={{
        endAdornment: <IconEdit></IconEdit>,
      }}
      {...props}
    />
  );
}
